import {type TestIdProps, testIdProps} from '@github-ui/test-id-props'
import {Box} from '@primer/styled-react'
import {clsx} from 'clsx'
import {type ComponentProps, type FC, forwardRef, type ReactNode, type RefObject} from 'react'

import styles from './core.module.css'

export const SidebarFields: FC<{
  listRef: RefObject<HTMLDListElement>
  children: ReactNode
}> = ({children, listRef}) => <dl ref={listRef}>{children}</dl>

export const Field: FC<{label: string; children: React.ReactNode} & TestIdProps> = ({label, children, ...props}) => (
  // div is default for Box, but PRC could change in the future and this is _required_ to be a div by HTML spec
  <div className={styles.fieldContainer} {...props}>
    <FieldLabel>{label}</FieldLabel>
    <dd className={styles.fieldValueContainer}>{children}</dd>
  </div>
)

const FieldLabel: FC<{children: ReactNode}> = ({children}) => <dt className={styles.fieldLabel}>{children}</dt>

export const FieldValue: FC<ComponentProps<typeof Box> & {interactable?: boolean; className?: string}> = forwardRef(
  ({interactable = false, children, className, sx, ...props}, ref) => {
    return (
      <Box
        // eslint-disable-next-line @github-ui/github-monorepo/no-sx
        sx={sx}
        {...props}
        ref={ref}
        className={clsx(styles.interactiveFieldValue, interactable && styles.interactable, className)}
        {...testIdProps('field-value')}
      >
        {children}
      </Box>
    )
  },
)
FieldValue.displayName = 'FieldValue'

try{ Field.displayName ||= 'Field' } catch {}
try{ FieldLabel.displayName ||= 'FieldLabel' } catch {}